import { render, staticRenderFns } from "./ConfirmHeading.vue?vue&type=template&id=6ec7399a&scoped=true&"
import script from "./ConfirmHeading.vue?vue&type=script&lang=js&"
export * from "./ConfirmHeading.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmHeading.vue?vue&type=style&index=0&id=6ec7399a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec7399a",
  null
  
)

export default component.exports